import { getMovimientosCuentaBancariaAll, newCargarMovimientosCuentaBancaria } from "../services/serviceUsuarios";


const dataInicial = {
  array: [],
  exito: 0,
  nombre: "0",
  referencia: "0",
  fechaInicio: "",
  fechaFinal: ""
};

const GET_PAGO_MASIVOS_CLEAR_STATE = "GET_PAGO_MASIVOS_CLEAR_STATE";
const GET_PAGO_MASIVOS_ALL = "GET_PAGO_MASIVOS_ALL";
const POST_PAGO_MASIVOS_NEW = "POST_PAGO_MASIVOS_NEW";

export default function pagosMasivosReducer(state = dataInicial, action) {
  switch (action.type) {
    case POST_PAGO_MASIVOS_NEW:
      return { ...state, exito: action.payload.exito, array: action.payload.array }
    case GET_PAGO_MASIVOS_ALL:
      return { ...state, array: action.payload.array, fechaInicio: action.payload.fechaInicio, fechaFinal: action.payload.fechaFinal };
    case GET_PAGO_MASIVOS_CLEAR_STATE:
      return {
        ...state,
        array: action.payload.array,
        exito: action.payload.exito,
      };
    default:
      return state;
  }
}

export const obtenerPagosMasivosAction = (fechaInicio, fechaFinal) => async (dispatch) =>{
  return await getMovimientosCuentaBancariaAll({fechaInicio, fechaFinal}).then((Response) =>{
    dispatch({
      type: GET_PAGO_MASIVOS_ALL,
      payload: {
        array: Response,
        fechaInicio,
        fechaFinal
      },
    });
  }).catch((Error) =>{
    return [];
  })
}

export const newPagoMasivoAction = (payload) => async (dispatch, getState) =>{
  const fechaInicio = getState().pagosMasivos.fechaInicio;
  const fechaFinal = getState().pagosMasivos.fechaFinal;
  const newDeposito = await newCargarMovimientosCuentaBancaria({payload});
  const newArray = await getMovimientosCuentaBancariaAll({fechaInicio, fechaFinal});
  dispatch({
    type: POST_PAGO_MASIVOS_NEW,
    payload: {
      exito: 1,
      array: newArray,
    },
  });
  return newDeposito;
}

export const clearUsuarioState = () => async (dispatch) => {
  dispatch({
    type: GET_PAGO_MASIVOS_CLEAR_STATE,
    payload: dataInicial,
  });
};
